import Vue from 'vue'
import store from '../store/index'
import VueI18n from 'vue-i18n'
import {
	Locale
} from 'vant'
import enUS from 'vant/lib/locale/lang/en-US'
import zhCN from 'vant/lib/locale/lang/zh-CN'
import zhTW from 'vant/lib/locale/lang/zh-TW'
import viVN from 'vant/lib/locale/lang/vi-VN'
// import koRean from 'vant/lib/locale/lang/ko'
// import thRean from 'vant/lib/locale/lang/th'
import enLocale from './en_us'
import zhLocale from './zh_cn'
import twLocale from './zh_tw'
import vnLocale from './vi_vn' //越南
import koLocale from './korean' //韩语
import thLocale from './thai' //泰语
Vue.use(VueI18n)

const messages = {
	en: {
		...enUS,
		...enLocale
	},
	zh: {
		...zhCN,
		...zhLocale
	},
	tw: {
		...zhTW,
		...twLocale
	},
	vn: {
		...viVN,
		...vnLocale
	},
	ko: {
		// ...koRean,
		...koLocale
	},
	th: {
		// ...thRean,
		...thLocale
	}
}

const i18n = new VueI18n({
	locale: store.state.ilang, // 设置默认语言
	messages: messages // 设置资源文件对象
})

// 更新vant组件库本身的语言变化，支持国际化
function vantLocales(lang) {
	if (lang === 'en') {
		Locale.use(lang, enUS)
	} else if (lang === 'zh') {
		Locale.use(lang, zhCN)
	} else if (lang === 'tw') {
		Locale.use(lang, zhTW)
	} else if (lang === 'vn') {
		Locale.use(lang, viVN)
	}else if (lang === 'ko') {
		// Locale.use(lang, koRean)
	}else if (lang === 'th') {
		// Locale.use(lang, thRean)
	}
}

// export {i18n, vantLocales}
export default i18n


// WEBPACK FOOTER //
// ./src/lang/index.js